export const saveDesignToLocalStorage = (product, id, designs) => {
  window.localStorage.setItem(
    `editor-designs-${product}-${id}`,
    JSON.stringify(designs)
  );
};

export const clearDesignFromLocalStorage = (product, id) => {
  window.localStorage.removeItem(`editor-designs-${product}-null`);
  window.localStorage.removeItem(`editor-designs-${product}-${id}`);
};

export const getDesignFromLocalStorage = (product, id) => {
  return JSON.parse(
    window.localStorage.getItem(`editor-designs-${product}-${id}`)
  );
};
